/* eslint-disable @typescript-eslint/no-duplicate-enum-values */


export enum UserState {
    ACTIVE = 'ACTIVE',
    INACTIVE = 'INACTIVE',
    NON_PAY_SUSPENDED = 'NON_PAY_SUSPENDED',
    NOT_SUBSCRIBED = 'NOT_SUBSCRIBED',
    CLOSED = 'CLOSED',
    HOTLINED = 'HOTLINED'
}

export enum UserErrorType {
    NOT_USER = 'non-user',
    SECONDARY_USER = 'secondary-user',
    XMB_COMING_SOON = 'xmb-coming-soon'
}

export enum AccountEligibilityStatus {
    ELIGIBLE = 'ELIGIBLE',
    INELIGIBLE_HOTLINED = 'INELIGIBLE_HOTLINED',
    INELIGIBLE_NON_PAY_SUSPEND = 'INELIGIBLE_NON_PAY_SUSPEND'
}

export enum PlanEligibilityStatus {
    ELIGIBLE = 'ELIGIBLE',
    INELIGIBLE_IN_USE = 'INELIGIBLE_IN_USE',
    INELIGIBLE_OVERAGE = 'INELIGIBLE_OVERAGE',
    REQUIRES_UPGRADE = 'REQUIRES_UPGRADE',
    INELIGIBLE_BUCKET = 'INELIGIBLE_BUCKET',
    INELIGIBLE_CHANGE_PENDING = 'INELIGIBLE_CHANGE_PENDING',
    INELIGIBLE_SCHEDULED = 'INELIGIBLE_SCHEDULED'
}

export enum LiabilityType {
    BUSINESS_LIABLE = 'BUSINESS_LIABLE',
    PERSONAL_LIABLE = 'PERSONAL_LIABLE'
}


export enum INSURANCE_PLAN_NAME {
    ACTIVE_PLAN = 'ACTIVE',
    XTDP = 'XTDP - Xfinity Total Device Protection',
    XTDP_PLUS = 'XTDP - Xfinity Total Device Protection Plus'
}
